import Helper from "../d3-common"
const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-zoom"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-voronoi"),
    require("d3-color"),
    require("d3-scale")
)

let dataset

export const ColParam = {
    init(theDataSet) {
        dataset = theDataSet
    },

    colorAccessor: d => Fn.getValuefromHex(d.color, "l"),

    getColor(datum, colorSource) {
        switch (colorSource) {
        // Ruturn the value that returns the color value
        case 1:
            return datum.color
        case 2:
            if (typeof datum.colors.main != "undefined") {
                return `rgb(${datum.colors.main[0][0]}, ${
                    datum.colors.main[0][1]
                }, ${datum.colors.main[0][2]})`
            } else {
                return "#FF0000"
            }

        case 3:
            if (typeof datum.colors.palette != "undefined") {
                return `rgb(${datum.colors.palette[0][0]}, ${
                    datum.colors.palette[0][1]
                }, ${datum.colors.palette[0][2]})`
            } else {
                return "#FF0000"
            }
        }
    },

    getDimensions(elementId) {
        const dim = Helper.getMaxDimensions(elementId)
        const vizWitdh = dim.w
        const vizHeigth = dim.h
        const vizRadius = dim.max

        const dimensions = {
            width: vizWitdh,
            height: vizHeigth,
            radius: vizRadius / 2,
            margin: {
                top: 30,
                right: 20,
                bottom: 30,
                left: 20
            }
        }
        dimensions.boundedWidth =
            dimensions.radius - dimensions.margin.left - dimensions.margin.right
        dimensions.boundedHeight =
            dimensions.radius - dimensions.margin.top - dimensions.margin.bottom
        dimensions.boundedRadius =
            dimensions.radius -
            (dimensions.margin.left + dimensions.margin.right) / 2

        return dimensions
    }
}

export const Scales = {
    color(v) {
        const scaleValue = d3
            .scaleLinear()
            .domain(d3.extent(dataset, ColParam.colorAccessor))
            .range([0.1, 0.9]) // offset

        return scaleValue(v)
    },

    angle() {
        return d3
            .scaleTime()
            .domain(d3.extent(dataset, dateAccessor))
            .range([0, Math.PI * 2]) // this is in radians
    },

    radius() {
        return d3
            .scaleLinear()
            .domain(
                d3.extent([
                    ...dataset.map(temperatureMaxAccessor),
                    ...dataset.map(temperatureMinAccessor)
                ])
            )
            .range([0, dimensions.boundedRadius])
            .nice()
    }
}

// Helpers
export const Fn = {
    getCoordinatesFromColor(color, offset = 1) {
        const hsl = d3.hsl(color)
        if (isNaN(hsl.h)) {
            hsl.h = 0
        }

        // const offset = Scales.color()
        return this.getCoordinatesForAngle(hsl.h, offset)
    },

    getCoordinatesForAngle(angle, offset = 1) {
        const dimensions = ColParam.getDimensions("color-viz")
        const dim = Helper.getMaxDimensions("color-viz")

        angle = (angle * Math.PI) / 180

        let hShift, vShift
        // Center circle
        if (dim.direction == "horizontal") {
            hShift =
                (dimensions.width - dimensions.height) / 2 +
                dimensions.boundedRadius
            vShift = dimensions.margin.top + dimensions.boundedRadius
        } else if (dim.direction == "vertical") {
            hShift = dimensions.margin.left + dimensions.boundedRadius
            vShift =
                (dimensions.height - dimensions.width) / 2 +
                dimensions.boundedRadius
        }

        return [
            Math.cos(angle - Math.PI / 2) * dimensions.boundedRadius * offset +
                hShift,
            Math.sin(angle - Math.PI / 2) * dimensions.boundedRadius * offset +
                vShift
        ]
    },

    getScreenCoords(x, y, ctm) {
        const xn = ctm.e + x * ctm.a + y * ctm.c
        const yn = ctm.f + x * ctm.b + y * ctm.d
        return { x: xn, y: yn }
    },

    getValuefromHex(color, value) {
        const hsl = d3.hsl(color)
        return hsl[value]
    },

    getXFromDataPoint() {
        return (d, offset = 1.38) =>
            getCoordinatesForAngle(angleScale(dateAccessor(d)), offset)[0]
    },

    getYFromDataPoint() {
        return (d, offset = 1.38) =>
            getCoordinatesForAngle(angleScale(dateAccessor(d)), offset)[1]
    }
}

export const Action = {
    removeCirclehighlight() {
        d3.selectAll(".tooltipDot").remove()
    },

    showToolTip(d) {
        const tooltip = d3.select("#tooltip")

        const w = tooltip.node().offsetWidth
        const h = tooltip.node().offsetHeight

        const circle = this
        const cx = +circle.getAttribute("cx")
        const cy = +circle.getAttribute("cy")
        const ctm = circle.getCTM()
        const coords = Fn.getScreenCoords(cx, cy, ctm)

        const x = coords.x - w / 2 + 20 // weird offset due to 45 angle
        const y = coords.y - h - 20

        d3.select("#tooltip")
            .style("opacity", 1)
            .style("transform", `translate(${x}px, ${y}px)`)
            .attr("data-id", d.id)
            .select("#pointer")
            .attr("data-id", d.id)
            .select("#view-btn")
            .attr("data-id", d.id)

        let imgEl = document.getElementById("pointer")
        imgEl.style.backgroundImage = "url('/assets/images/loading.gif')"

        Helper.loadImage(
            `${
                d.urls.raw
            }&w=200&h=200&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`
        ).then(img => {
            let photoURL = img.src
            imgEl.style.backgroundImage = "url(" + photoURL + ")"
        })

        // Add the color palette
    },
    showToolTipVoronoi(d) {
        const datum = d.data
        const tooltip = d3.select("#tooltip")

        const w = tooltip.node().offsetWidth
        const h = tooltip.node().offsetHeight

        const idSelector = `#c-${datum.id}` // '#-LaitanJfas' //
        const circle = d3.select(idSelector).node()

        const cx = +circle.getAttribute("cx")
        const cy = +circle.getAttribute("cy")
        const ctm = circle.getCTM()
        const coords = Fn.getScreenCoords(cx, cy, ctm)

        const x = coords.x - w / 2 + 20 // weird offset due to 45 angle
        const y = coords.y - h - 20

        // Palette
        function convertToRGB(num) {
            return `rgb(${datum.colors.palette[num][0]}, ${
                datum.colors.palette[num][1]
            }, ${datum.colors.palette[num][2]})`
        }

        for (let x=0 ;x<5; x += 1){
            d3.select(`#p${x+1}`).style("background-color", convertToRGB(x))
        }
        

        tooltip
            .style("opacity", 1)
            .style("transform", `translate(${x}px, ${y}px)`)
            .attr("data-id", datum.id)
            .select("#pointer")
            .attr("data-id", datum.id)
            .select("#view-btn")
            .attr("data-id", datum.id)

        let imgEl = document.getElementById("pointer")
        imgEl.style.backgroundImage = "url('/assets/images/loading.gif')"

        Helper.loadImage(
            `${
                datum.urls.raw
            }&w=200&h=200&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`
        ).then(img => {
            let photoURL = img.src
            imgEl.style.backgroundImage = "url(" + photoURL + ")"
        })
    },

    hideToolTip() {
        d3.select("#tooltip")
            .style("opacity", 0)
            .style("transform", `translate(-10000px, -10000px)`)
    }
}

export default Action
